
import _ from "lodash"
import { Select, Option, Input } from "element-ui"
import { getStoreRegions } from "@/api/delivery"

export default {
  name: "FilterBar",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  props: {
    storeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter: {
        searchValue: "",
        regionValue: "", // 香港
        municipalValue: "", // 新界
        districtValue: "" // 大埔区
      },
      allOptions: [],
      regionOptions: [],
      municipalOptions: [],
      districtOptions: []
    }
  },
  mounted() {
    this.clearFilter()
    this.getRegionOptions()
  },
  methods: {
    reset() {
      const { searchValue = "", regionValue = "", municipalValue = "" } = this.filter
      if (!searchValue && !regionValue && !municipalValue) return
      this.allOptions = []
      this.regionOptions = []
      this.municipalOptions = []
      this.districtOptions = []
      this.getRegionOptions()
      this.clearFilter()
      this.handleFilter()
    },
    clearFilter() {
      this.filter = {
        searchValue: "",
        regionValue: "",
        municipalValue: ""
      }
    },
    async getRegionOptions() {
      try {
        const { data: res } = await getStoreRegions()
        this.allOptions = res || []
        // 默认单独筛选出香港和澳门特别行政区
        this.regionOptions = res.reduce((acc, item) => {
          // 检查是否已经包含这个省级
          const exists = acc.some(prov => prov.provincial === item.provincial)
          if (!exists) {
            acc.push({
              provincial: item.provincial,
              provincialName: item.provincialName
            })
          }
          return acc
        }, [])
        // 默认渲染二级区域
        this.municipalOptions = _.uniqBy(res, "municipal")
        this.districtOptions = _.uniqBy(res, "district")
      } catch (error) {
        console.log(error)
      }
    },
    // 根据行政区选择，渲染地域
    handleRegionChange(value) {
      console.log(value)
      this.filter.municipalValue = ""
      this.filter.districtValue = ""
      // 根据区域数据进行过滤去重
      this.municipalOptions = this.filter.regionValue
        ? _.uniqBy(
            this.allOptions.filter(item => item.provincial === value),
            "municipal"
          )
        : _.uniqBy(this.allOptions, "municipal")
      this.handleFilter()
    },
    // 切换清空澳门或香港相关门店二级区域逻辑
    handleMunicipalChange(value) {
      if (!this.filter.regionValue) {
        const translatedMessage = this.$t("deliveryMethod.selectRegion")
        this.$message({
          message: translatedMessage,
          type: "warning"
        })
        this.filter.municipalValue = ""
        return
      }
      this.filter.regionValue = ""
      this.filter.districtValue = ""
      const district = this.municipalOptions.filter(e => e.municipal === value)[0]
      this.filter.regionValue = district.provincial
      this.districtOptions = this.allOptions.filter(e => e.municipal === value)
      this.handleFilter()
    },

    // 切换清空澳门或香港相关门店三级区域逻辑
    handleDistrictChange(value) {
      if (!this.filter.regionValue) {
        const translatedMessage = this.$t("deliveryMethod.selectRegion")
        this.$message({
          message: translatedMessage,
          type: "warning"
        })
        this.filter.districtValue = ""
        return
      }

      if (!this.filter.municipalValue) {
        const translatedMessage = this.$t("deliveryMethod.selectMunicipal")
        this.$message({
          message: translatedMessage,
          type: "warning"
        })
        this.filter.districtValue = ""
        return
      }
      this.filter.regionValue = ""
      this.filter.municipalValue = ""
      const district = this.districtOptions.filter(e => e.district === value)[0]
      this.filter.regionValue = district.provincial
      this.filter.municipalValue = district.municipal
      this.handleFilter()
    },
    handleSearch: _.debounce(function () {
      this.handleFilter()
    }, 200),
    handleClear() {
      this.filter.searchValue = ""
      this.handleFilter()
    },
    getFilterList(filter) {
      // 系统返回香港澳门所有门店
      let filterList = _.cloneDeep(this.storeList)
      const { searchValue = "", regionValue = "", municipalValue = "", districtValue = "" } = filter
      if (searchValue) {
        const value = searchValue.toLowerCase()
        filterList = filterList.filter(
          item => item.name?.toLowerCase()?.includes(value) || item.address?.toLowerCase()?.includes(value)
        )
      }
      // 根据区域进行筛选门店逻辑
      if (regionValue) {
        filterList = filterList.filter(item => item.provincial === regionValue)
      }
      if (municipalValue) {
        filterList = filterList.filter(item => item.municipal === municipalValue)
      }
      if (districtValue) {
        filterList = filterList.filter(item => item.district === districtValue)
      }
      return filterList || []
    },
    handleFilter() {
      this.$emit("filter", this.getFilterList(this.filter), this.filter.searchValue)
    }
  }
}
